
    // this file was auto generated by python script
    import Lock from './Lock';
    export default Lock;
    